import Cursor from "./Cursor";

export default function CursorTrail() {
  return <Cursor width={16} height={16} bgcolor="custom.primary" />;
}
